<template>
    <div>
        <commonheader @getNewsId='getNewsId'></commonheader>
        <el-container class="el-container-master">
            <div class="content">
                <div class="crumbsNavCont">
                    <p class="crumbsNav">位置：首页>{{ typeName }}</p>
                    <div class="searchBox">
                        <search></search>
                    </div>
                </div>
                <div class="subPageCont">
                    <div class="subNewList fl" v-loading='loading'>
                        <commonnewlist :listData="listData" :newListStyle3="true"></commonnewlist>
                    </div>
                    <div class="contactUsBox fr">
                        <contactus :contactStyle2="true"></contactus>
                    </div>
                </div>
                <!--新闻列表分页-->
                <div class="paginationBox" >
                    <el-pagination background :current-page.sync="currentPage" v-if='listTotal' @current-change="handleCurrentChange" layout="prev, pager, next" :total="listTotal" :page-size='10'>
                    </el-pagination>
                </div>
            </div>
        </el-container>
        <commonfooter></commonfooter>
    </div>
</template>

<script>
import commonheader from './common/commonHeader.vue' //头部组件
import commonfooter from './common/commonFooter.vue' //底部组件
import commonnewlist from './common/commonNewList.vue' //新闻列表组件
import search from './common/search.vue' //搜索组件
import contactus from './common/contactUs.vue' //右侧联系我们组件
export default {
    components: {
        commonheader,
        commonfooter,
        commonnewlist,
        search,
        contactus,
    },
    data () {
        return {
            listData: [],
            currentPage: 1,
            listTotal: 0,
            typeName: '',
            loading: true
        };
    },
    mounted () {
        this.$route.query && this.$route.query.newsId && this.getNewList(this.$route.query.newsId);
        this.getTypeName();
    },
    methods: {
        /**
         * 获取列表类型名称
         */
        getTypeName () {
            //小导航
            let id = this.$route.query.newsId;
            let obj = {
                '1':'协会动态',
                '2':'办事指南',
                '3':'继续教育',
                '4':'新闻资讯',
                '5':'药学服务',
                '21':'党群工作',
                '22':'会员风采'
            }
            this.typeName = obj[id];
        },
        /**
         * 获取newsId
         * 相同页面跳转mounted不生效，子组件把newsId传过来
         */
        getNewsId (newsId) {
            this.currentPage = 1;
            this.getNewList(newsId);
            this.getTypeName();
        },
        /**
         * 分页-改变
         */
        handleCurrentChange (val) {
            this.currentPage = val
            this.getNewList(this.$route.query.newsId);
        },
        /**
         * 获取列表数据
         */
        getNewList (id) {
            //初始化
            this.listData = [];
            this.listTotal = 0;

            let navCategoryPageParams = {
                catid: id,
                limit: 10,
                page: this.currentPage
            }
            this.loading = true;
            this.$store.dispatch('navCategoryPage', navCategoryPageParams)
                .then((res) => {
                    if (res.code == 200) {
                        if (Array.isArray(res.data)) {
                            this.listData = [];
                            this.listTotal = 0;
                        } else {
                            this.listTotal = res.data.total
                            this.listData = res.data.data
                        }
                    }
                    this.loading = false;

                }).catch(error => {
                    console.log('错误信息：', error)
                    this.loading = false;
                })
        }
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
@media (min-width: 1399px) {
    .el-container-master {
        width: 1200px;
        margin: auto;
    }
}
.el-container-master {
    flex-direction: column;
    min-height: 700px;
}

.content {
    /* width:1400px;
  margin: 0 auto; */
    padding-bottom: 40px;
}

.crumbsNavCont {
    width: 100%;
    padding-right: 300px;
    height: 70px;
    border-bottom: 1px solid #d8d8d8;
    position: relative;
    box-sizing: border-box;
}
.crumbsNav {
    font-size: 14px;
    color: #222;
    height: 100%;
    line-height: 70px;
}

.subPageCont {
    margin-top: 10px;
    position: relative;
}
.searchBox {
    position: absolute;
    right: 0;
    top: 50%;
    transform: translateY(-50%);
}
.subNewList {
    width: 880px;
}

.contactUsBox {
    width: 265px;
    position: absolute;
    right: 0;
    top: 0;
}

.paginationBox {
    clear: both;
    padding-top: 60px;
    text-align: center;
    margin-right: 265px;
}
</style>



// WEBPACK FOOTER //
// src/components/newsList.vue